import { css } from '@emotion/react'

import Text from './Text'

export default function FormLabel(props: { htmlFor?: string; children: React.ReactNode }) {
  return (
    <label
      htmlFor={props.htmlFor}
      css={css`
        display: block;
      `}
    >
      <Text bold>{props.children}</Text>
    </label>
  )
}
